module.exports = __webpack_public_path__ + "img/img50.f32f7727.svg";